import { apiService } from "../api.service";

// Domain
import { ChatMessage, Pagination } from "../../models/app/domain";

/**
 * Fetch chat messages Request
 * @return - ChatMessagesResponse || ErrorResponse
 */
export const fetchChatMessagesRequest = async (serviceId, from) => {
  let fromQuery = "";
  if (from) {
    fromQuery = `&from=${from}`;
  }
  const response = await apiService.get(
    `/chat/${serviceId}?limit=20${fromQuery}`
  );
  if (response.hasError) {
    return response;
  }
  return {
    messages: response.data.messages.map(message => new ChatMessage(message)),
    pagination: new Pagination(response.data.pagination)
  };
};
